/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignAclIndexPathParams,
	CampaignAclIndexQueryParams,
	CampaignAclIndexResponse,
} from '../types/CampaignAclIndex'

/**
 * GET /campaigns/:campaign/access
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignAclController.php CampaignAclController::index
 */
export async function campaignAclIndex(
	campaign: CampaignAclIndexPathParams['campaign'],
	params?: CampaignAclIndexQueryParams,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignAclIndexResponse>> {
	return axiosInstance.get(`/campaigns/${campaign}/access`, { params, ...config })
}
